const STROKE_SCALE_FACTOR = 10;

type SquareShapeProps = {
  fill?: string;
  stroke?: string;
  strokeWidth?: number;
  width?: number;
  height?: number;
  borderRadius?: number;
  lockAspectRatio?: boolean;
} & React.SVGProps<SVGSVGElement>;

const SquareShapeComponent: React.FC<SquareShapeProps> = ({
  fill = 'none',
  width = 200,
  height = 200,
  stroke = 'none',
  strokeWidth = 0,
  borderRadius = 0,
  lockAspectRatio: _lockAspectRatio,
  ...rest
}) => {
  const scaledStrokeWidth = strokeWidth * STROKE_SCALE_FACTOR;
  const inset = scaledStrokeWidth / 2;

  const outerWidth = width - scaledStrokeWidth;
  const outerHeight = height - scaledStrokeWidth;

  const innerWidth = width - scaledStrokeWidth * 2;
  const innerHeight = height - scaledStrokeWidth * 2;

  const innerRx = Math.max(0, Math.min(innerWidth / 2, borderRadius - inset));
  const innerRy = Math.max(0, Math.min(innerHeight / 2, borderRadius - inset));

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      preserveAspectRatio="none"
      xmlns="http://www.w3.org/2000/svg"
      vectorEffect="non-scaling-stroke"
      {...rest}
    >
      <rect
        width={outerWidth}
        height={outerHeight}
        x={inset}
        y={inset}
        rx={borderRadius}
        ry={borderRadius}
        fill="none"
        stroke={stroke}
        strokeWidth={scaledStrokeWidth}
      />
      <rect width={innerWidth} height={innerHeight} x={scaledStrokeWidth} y={scaledStrokeWidth} rx={innerRx} ry={innerRy} fill={fill} />
    </svg>
  );
};

export default SquareShapeComponent;
